import { gql } from '@apollo/client';

export const GET_INFLUENCER_CATEGORIES = gql`
  query GetInfluencerCategories {
    getInfluencerCategories {
      id
      name
    }
  }
`;
